const copyToClipboard = (value: string): Promise<void> =>
  navigator.clipboard.writeText(value);

const copyToClipboardWithFeedback = (
  value: string,
  onSuccess: () => void,
  onError: () => void,
): void => {
  if (!navigator?.clipboard?.writeText) {
    onError();
    return;
  }
  void copyToClipboard(value).then(onSuccess).catch(onError);
};

export const clipboardUtils = {
  copyToClipboard,
  copyToClipboardWithFeedback,
};
